import { getDefaultOrgRole } from '../../../../backend/features/organizations/shared/getDefaultOrgRole';
import { allowOrgMembersEdit, getAccountsViewFilterNew, requireAnySystemPermission } from '../../../../backend/features/permissions/shared';
import { forEachEntityRow } from '../../../../backend/utils';
import { getErrorMessage } from '../../../../backend/utils/getErrorMessage';
import { AuthError } from '@juvare/platform-app/App';
import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
import { addAccountsToOrganizationBulkActionType } from '../shared';
import { getAccountStorage } from '../utils/getAccountStorage';
import { transformOrgColumnIntoDataObject } from '../utils/transformOrgColumnIntoDataObject';
export const addAccountsToOrganization = defineBulkAction({
    type: addAccountsToOrganizationBulkActionType,
    onAuthBulkAction: (userContext, { data }) => {
        if (!allowOrgMembersEdit(userContext.userState)) {
            throw new AuthError('Unauthorized');
        }
        return {
            secureFilter: [
                ...getAccountsViewFilterNew(userContext.userState, requireAnySystemPermission(userContext.userState, 'manage-accounts-organizations')),
                ...data.params.filter,
            ],
        };
    },
    onProcessBulkAction: (appContext, { data, isCancelled, updateTotalCount, updateProcessedCount }) => {
        const accountStorage = getAccountStorage(appContext);
        const defaultRole = getDefaultOrgRole(appContext.appState.settings.orgRoleMap);
        forEachEntityRow(accountStorage, { filter: data.secureParams.secureFilter, orderBy: [{ column: 'email' }] }, (row, idx) => {
            try {
                const orgRoles = transformOrgColumnIntoDataObject(row.columns.orgRole);
                const orgStatuses = transformOrgColumnIntoDataObject(row.columns.orgStatus);
                if (!orgRoles[data.params.organizationId]) {
                    accountStorage.post({
                        action: 'partial-update',
                        id: row.id,
                        data: {
                            orgRole: Object.assign(Object.assign({}, orgRoles), { [data.params.organizationId]: defaultRole || 'user' }),
                            orgStatus: Object.assign(Object.assign({}, orgStatuses), { [data.params.organizationId]: 'accepted' }),
                        },
                    });
                }
            }
            catch (error) {
                console.error('Failed to process addAccountsToOrganization bulk action', data.params, getErrorMessage(error));
            }
            updateProcessedCount(idx + 1);
            return { cancel: isCancelled() };
        }, updateTotalCount);
    },
});
